export function isEqualRect(target, source) {
  if (target == null || source == null) {
    return false;
  }

  if (target === source) {
    return true;
  }

  return (
    target.width === source.width && target.height === source.height && target.x === source.x && target.y === source.y
  );
}

export function isVisible(rect, boundary) {
  if (!boundary) {
    return true;
  }

  return (
    rect.x + rect.width >= boundary.x &&
    rect.x <= boundary.x + boundary.width &&
    rect.y + rect.height >= boundary.y &&
    rect.y <= boundary.y + boundary.height
  );
}

export function getScrollParent(node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

export function getPlacement(anchorRect) {
  const left = anchorRect.x + anchorRect.width;
  const top = anchorRect.y;

  return { left, top };
}
